// Choix du séjour à proposer (décision 16 du planning).
// Un séjour : { stay_number, arrival_time, departure_time, status, … } (dates en secondes).
// `isStaffDone(stay, type)` dit si l'inventaire staff de ce type est déjà fait pour ce séjour.

import { DAY, formatShortDate, formatRange } from './fieldDates'

export const WINDOW_DAYS = 7
export const NEIGHBOR_COUNT = 3

function usableStays(stays)
{
	return (stays || [])
		.filter(stay => stay && stay.status !== 'canceled' && stay.arrival_time && stay.departure_time)
		.sort((a, b) => a.arrival_time - b.arrival_time)
}

export function isCurrentStay(stay, now)
{
	return stay.arrival_time <= now && now < stay.departure_time
}

// Sortie : le séjour en cours, sinon le dernier parti dans les 7 jours.
// Entrée : le séjour en cours dont l'entrée n'est pas faite, sinon le prochain à arriver dans les 7 jours.
export function proposeStay(stays, type, now, isStaffDone = () => false)
{
	const list = usableStays(stays).filter(stay => !isStaffDone(stay, type))
	const windowSec = WINDOW_DAYS * DAY
	const current = list.find(stay => isCurrentStay(stay, now))
	if (current)
		return current
	if (type === 'departure')
	{
		const gone = list
			.filter(stay => stay.departure_time <= now && stay.departure_time >= now - windowSec)
			.sort((a, b) => b.departure_time - a.departure_time)
		return gone[0] || null
	}
	const coming = list
		.filter(stay => stay.arrival_time > now && stay.arrival_time <= now + windowSec)
		.sort((a, b) => a.arrival_time - b.arrival_time)
	return coming[0] || null
}

// « Pas le bon séjour ? » : 3 séjours avant et 3 après, hors fenêtre comprise.
// Le pivot est le séjour proposé, ou à défaut la date du jour.
export function neighborStays(stays, proposed, now)
{
	const list = usableStays(stays)
	let pivot = -1
	if (proposed)
		pivot = list.findIndex(stay => stay.stay_number === proposed.stay_number)
	let previous = []
	let next = []
	if (pivot >= 0)
	{
		previous = list.slice(Math.max(0, pivot - NEIGHBOR_COUNT), pivot)
		next = list.slice(pivot + 1, pivot + 1 + NEIGHBOR_COUNT)
	}
	else
	{
		let firstFuture = list.findIndex(stay => stay.arrival_time > now)
		if (firstFuture < 0)
			firstFuture = list.length
		previous = list.slice(Math.max(0, firstFuture - NEIGHBOR_COUNT), firstFuture)
		next = list.slice(firstFuture, firstFuture + NEIGHBOR_COUNT)
	}
	return { previous: previous.reverse(), next }
}

export function guestName(client)
{
	if (!client)
		return ''
	return ((client.firstname || '').trim() + ' ' + (client.lastname || '').trim()).trim()
}

// « Séjour n° 48213 · parti le 19 oct. »
export function stayMomentLabel(stay, type, now)
{
	if (type === 'departure')
	{
		const date = formatShortDate(stay.departure_time, now)
		return stay.departure_time <= now ? 'parti le ' + date : 'départ le ' + date
	}
	return 'arrivée le ' + formatShortDate(stay.arrival_time, now)
}

export function stayDatesLabel(stay, now)
{
	return formatRange(stay.arrival_time, stay.departure_time, now)
}
